<template>
  <div class="reserve-warp" id="reserveWarp">
    <div class="reserve-main">
      <div class="close" @click="close"></div>
      <div class="tit">{{ type == 3 ? '到货通知' : '立即预约' }}</div>
      <div class="cut">
        <p class="tip">我们会在到货的第一时间提醒您</p>
        <div class="txt">
          <input
            v-model="telNo"
            class="phone"
            type="tel"
            placeholder="请输入您的手机号码"
            maxlength="11"
            @keyup="keyUp"
          />
        </div>
        <p class="err-tip">
          {{ errorTips ? '请输入正确的手机号码' : '' }}
        </p>
      </div>
      <div class="foo">
        <a href="javascript:;" class="btn" :class="{ disabled: telNo === '' }" @click="submit">提交</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isPhone } from 'utils/reg'
import { freeAppoint } from '../../../index/api'

export default {
  props: {
    type: Number
  },
  computed: {
    ...mapState('detailv3', ['skuInfo'])
  },
  data() {
    return {
      telNo: '',
      errorTips: false,
      // 防重点
      isDoing: false
    }
  },
  methods: {
    /**
     * 关闭弹框
     */
    close() {
      this.telNo = ''
      this.errorTips = false
      this.$emit('close')
    },

    /**
     * 输入框keyup事件
     */
    keyUp() {
      this.errorTips = this.telNo.trim() == ''
    },

    /**
     * 提交按钮点击事件
     */
    submit() {
      // 检查是否是手机号
      if (isPhone(this.telNo.trim())) {
        this.reserveSubmit()
      } else {
        this.errorTips = true
      }
    },

    /**
     * 到货通知、立即预约提交
     */
    reserveSubmit() {
      let _this = this
      let title = this.type == 3 ? '登记' : '预约'
      if (this.isDoing) {
        return
      }
      this.isDoing = true
      let param = {
        appointType: _this.type,
        skuId: _this.skuInfo?.commoditySkuBaseInfo?.skuId,
        phone: _this.telNo.trim()
      }
      freeAppoint(param)
        .then(() => {
          _this.isDoing = false
          _this.$toast({
            type: 'html',
            message: `<span class="reserve-toast-common"><p class="toast-title"><i></i><span>${title}成功</span></p><p class="toast-des">我们会在到货的第一时间提醒您</p></span>`
          })
          _this.close()
        })
        .catch(e => {
          _this.isDoing = false
          _this.$toast(e.msg)
          _this.close()
        })
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
